import SelectItem from '@/common/interfaces/SelectItem';
import { Component, Watch, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import SizeBreakpoints from '@/common/interfaces/SizeBreakpoints';

import Dropdown from './Dropdown/Dropdown.vue';
import ButtonClose from '@/components/ButtonClose/ButtonClose.vue';
import vSelect from 'vue-select';

import CtaButton from '@/components/CtaButton/CtaButton.vue';
import CtaLinkItem from '../../common/interfaces/CtaLinkItem';

import Chevron from '@/assets/icons/chevron.svg?inline';
import {
  TeamExpeditionFinderState,
  GET_ITINERARIES_REQUEST,
  GET_DATES_REQUEST,
  CLEAR_FILTERS,
  SET_CURRENT_DATE,
  SET_STAGE,
} from './TeamExpeditionFinderModule.store';
import { mixins } from 'vue-class-component';
import StoreModuleMixin from '@/mixins/StoreModuleMixin';
import { GetDepartureUrl } from './TeamExpeditionFinderModule.api';
import ExpeditionTeamDisclaimer from './ExpeditionTeamDisclaimer/ExpeditionTeamDisclaimer.vue'
import { GET_MODULES } from '@/store/modules/modulesLoadModule';
@Component({
  components: {
    vSelect,
    ButtonClose,
    Chevron,
    Dropdown,
    CtaButton,
    ExpeditionTeamDisclaimer,
  },
})
export default class TeamExpeditionFinderModule extends mixins(StoreModuleMixin) {
  @Prop({ type: Array as () => SelectItem[] })
  destinations: SelectItem[];

  buttonApply: CtaLinkItem = { Link: '', Title: 'Apply' };

  @Prop(String)
  title!: string;

  @Prop(Boolean)
  isExpanded!: boolean;

  @Prop(Boolean)
  isVisible!: boolean;

  @Prop(Number)
  destinationId!: number;

  @Prop(Number)
  itineraryId!: number;

  state!: TeamExpeditionFinderState;

  getItineraries: (destinationId: number) => void = this.getAction(GET_ITINERARIES_REQUEST);
  getDates: (itineraryId: number) => void = this.getAction(GET_DATES_REQUEST);
  setCurrentDateRequest: (dateId: number) => void = this.getMutation(SET_CURRENT_DATE);
  setCurrentStageRequest: (stage: number) => void = this.getMutation(SET_STAGE);
  clearFilters: () => void = this.getMutation(CLEAR_FILTERS);

  async created() {
    await this.populateSearchByParameters();
  }

  get itineraries() {
    return this.state.Itinararies;
  }

  get dates() {
    return this.state.Dates;
  }

  get IsDisableItineraries() {
    return !(this.itineraries && this.itineraries.length > 0);
  }

  get IsDisableDates() {
    return !(this.dates && this.dates.length > 0);
  }

  get stage() {
    return this.state.DropdownStage;
  }

  get canApply() {
    return this.state.DestinationId && this.state.ItineraryId && this.state.DateId;
  }

  async setCurrentDate(dateId: number) {
    this.buttonApply.Link = await GetDepartureUrl(dateId);
    this.setCurrentDateRequest(dateId);
    this.setCurrentStageRequest(3);
  }

  async populateSearchByParameters() {
    if (!this.destinationId || !this.itineraryId) return;
    try{
      await this.getItineraries(this.destinationId);
      await this.getDates(this.itineraryId);
    } catch (err){
      //console.log(err);
    }
  }

  handleClickEvent(evt, value) {
    evt.stopPropagation();
    this.$emit('clicked', value);
  }

  clearDropdowns() {
    this.clearFilters();
  }

  @Getter isInBreakpoint!: (breakpoints: SizeBreakpoints[] | SizeBreakpoints) => boolean;
  get isMobileWidth() {
    return this.isInBreakpoint(['xs', 'sm', 'md']);
  }

  @Watch('isVisible')
  handleVisibilityChange(newVal: boolean, oldVal: boolean) {
    this.clearDropdowns();
  }

  get disclaimerMessage() {
    const message = this.$store.getters[GET_MODULES].find(m => m.Type.includes('FilterableGridModule'))?.Data?.DisclaimerMessage;
    return message;
  }
}
